import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import { GrowRole } from '@core/tellent-skills-types';
import { ORG_GUID } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class GrowRolesHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);
  private readonly orgGuid = inject(ORG_GUID)!;

  public fetchRoles(): Observable<GrowRole[]> {
    return this.httpApi
      .get(`/positions/org/${this.orgGuid}/roles`, null, { skipCompany: true })
      .pipe(
        map((response: { roles: GrowRole[] }) => response.roles),
        take(1),
      );
  }
}
